import { render, staticRenderFns } from "./viewPriorityMapping.vue?vue&type=template&id=4af5f601&scoped=true"
import script from "./viewPriorityMapping.vue?vue&type=script&lang=js"
export * from "./viewPriorityMapping.vue?vue&type=script&lang=js"
import style0 from "./viewPriorityMapping.vue?vue&type=style&index=0&id=4af5f601&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af5f601",
  null
  
)

export default component.exports